<a class="related-deal pl-2 pr-2" routerLink="/{{'deal_url' | translate}}/{{deal.link_id}}-{{deal.link_title_url | urlSafe}}">
    <div class="flex flex-column border-1 border-solid border-round border-300 p-1">
        <div class="relative align-self-center text-center">
            <img src="{{deal.link_image | dealimageurl }}"
                 class="flex deal-related-image"
                [appImgFallback]="imageFallback">
        </div>
        <div class="flex">
            <p class="font-bold text-l deal-preview-link ">{{deal.link_title | replacespaces}}</p>
        </div>
        <div class="flex flex-column justify-content-end align-items-center">
            <p *ngIf="deal.link_price == 0" class="flex font-semibold text-lg deal-preview-price justify-content-center mt-0 mb-0">{{'free' | translate}}</p>
            <p *ngIf="deal.link_price != 0" class="flex font-semibold text-lg deal-preview-price justify-content-center mt-0 mb-0">{{ deal.link_price | number: '1.0-2'}}{{'currency_unit' | translate}}</p>
            <div class="flex flex-row justify-content-around align-items-center">
                <p *ngIf="oldPriceVisible" class="flex font-medium text-sm mt-0 mb-0 strikethrough">{{ deal.link_list_price | number: '1.0-2'}}{{'currency_unit' | translate}}</p>&nbsp;
                <p *ngIf="savingVisible" class="flex font-medium text-sm deal-preview-saving mt-0 mb-0">{{ deal.link_percent_off }}%</p>
            </div>
        </div>
      </div>
</a>
